import styled from 'styled-components';

import { fontStyle } from '../../../../theme/helpers/fontStyle';

export const $NoteContainer = styled.div`
  ${fontStyle('sm')};
`;
